<template>
		<div>
			<div class="doctorPage doctorSeach managerPlan">
				<div class="selectSearch">
					<el-form ref="form" :model="listParameter" class="qcFrom" :inline="true">
						<el-form-item label="状态">
						    <el-select v-model="listParameter.enable" placeholder="请选择" size="mini" class="name" >
								<el-option label="全部" value="-1"></el-option>
								<el-option label="启用" value="1"></el-option>
								<el-option label="禁用" value="0"></el-option>
						    </el-select>
						  </el-form-item>
						<el-form-item label="关键词">
							<el-input v-model="listParameter.name" class="name" placeholder="请输入角色名称" size="mini"></el-input>
						</el-form-item>
						<el-form-item>
						<el-button type="primary" @click="search" round>查询</el-button>
						</el-form-item>
						<a href="javascript:;" class="addbtn" @click="newlyBuild">新建角色</a>
					</el-form>
				</div>
				<!-- 中间内容 -->
				<div class="centerHome">
					<div class="ccHomel">
						<div class="compentTable">
							<el-table class="qcTable" :data="rolesList" v-loading="loading">
								<el-table-column prop="StationName" label="工作站名称" min-width="100"></el-table-column>
								<!-- <el-table-column prop="RoleName" label="角色名称" min-width="100"></el-table-column> -->
								<el-table-column prop="CreateDt" label="创建时间"></el-table-column>
								<el-table-column prop="Enable" label="状态">
									<template slot-scope="scope">
										<span v-show="scope.row.Enable == 0">禁用</span>
										<span v-show="scope.row.Enable == 1">启用</span>
									</template>
								</el-table-column>
								<el-table-column prop="" label="操作" width="180">
									<template slot-scope="scope">
										<span class="table-task-btn detail" @click="showClick(scope.row)">编辑</span>
										<span class="table-task-btn delete" @click="delterClick(scope.row)">删除</span>
									</template>
								</el-table-column>
							
							</el-table>
						<!-- 	<div class="pages">
								<el-pagination class="pageAll" layout="prev, pager, next" :total="roleTotal" :page-size='listParameter.PageCount' :current-page='listParameter.PageIndex' @current-change='currentChange'>
								</el-pagination>
							</div> -->
						</div>
					</div>
				</div>
				<el-dialog :title="title" :visible.sync="dialogVisible" :close-on-click-modal='false' width="50%" class="scrollbar listParameter dialogFrom">
					<el-form label-width='100px' class="qcFrom dialogScoped" ref="setlistParameter" :rules="rules" distinguishCancelAndClose :model="submitParameter">
						<el-row>
							<el-col :span="16">
								<el-form-item label="状态">
									<div class="exportTab marr20">
										<div class="sliderScreeningR">
											<a href="javascript:;" @click="seachTab(1)" :class="submitParameter.Enable?'active':''">启用</a>
											<a href="javascript:;" @click="seachTab(0)" :class="!submitParameter.Enable?'active':''">禁用</a>
										</div>
									</div>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="16">
								<el-form-item label="工作站名称" prop="RoleName">
									<el-input size="small" v-model="submitParameter.StationName" placeholder="请输入工作站名称"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="16">
								<el-form-item label="角色名称" prop="RoleName">
									<el-input size="small" v-model="submitParameter.RoleName" placeholder="请输入角色名称"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="16">
								<el-form-item label="图标名称" prop="Icon">
									<el-input size="small" v-model="submitParameter.Icon" placeholder="请输入图标名称"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
					<div class="dialog-footer mart25" align="center">
						<el-button type="primary" @click="preservation()">保 存</el-button>
					</div>
				</el-dialog>
			</div>
		</div>
	</template>
	
<script>
	import { mapState, mapActions, mapMutations } from 'vuex'
	import axios from '@/js/api'
	export default{
		data(){
			return {
				submitParameter:{
				  "RoleGuid": "",
				  "RoleName": "",
				  "Enable": '0',
				  "IsDeleted": false
				},
				title:'新建角色',
				dialogVisible:false,
				rules: {
					RoleName: [{
						required: true,
						message: '请输入角色名称',
						trigger: 'blur'
					}],
					StationName: [{
						required: true,
						message: '请输入工作站名称',
						trigger: 'blur'
					}],
				},
				message:'保存'
			}
		},
		computed: {
			...Vuex.mapState('breadcrumb', ['loading']),
			...Vuex.mapState('admin', ['rolesList','listParameter','roleTotal']),
		},
		activated(){
			this.listParameter.pageIndex = 1;
			this.GetRoles({
				enable:'-1'
			})
		},
		methods:{
			...Vuex.mapMutations('breadcrumb', ['setLoading']),
			...Vuex.mapActions('admin', ['GetRoles']),
			newlyBuild(){
				this.dialogVisible = true;
			},
			delterClick(row){
				let _this = this;
				this.submitParameter.RoleGuid = row.RoleGuid;
				this.submitParameter.RoleName = row.RoleName;
				this.$confirm('确定删除此角色？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					_this.submitParameter.IsDeleted = true;
					_this.updateRole()
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			showClick(row){
				this.title = '编辑角色'
				this.message = '修改'
				this.dialogVisible = true;
				this.submitParameter = JSON.parse(JSON.stringify(row));
			},
			// 增删改请求
			updateRole(){
				let _this = this;
				_this.setLoading(true);
				axios.ajaxPost('post', axios.Api.api.admin.CreateOrUpdateRole,_this.submitParameter).then(res => {
					if (res.data.StatusCode == 200) {
						_this.$message.success(_this.message + '成功');
						_this.setLoading(false);
						_this.GetRoles({
							enable:'-1'
						})
					}
				})
			},
			search(){
				this.GetRoles({
					enable:this.listParameter.enable
				})
			},
			//分页
			currentChange(val) {
				this.listParameter.pageIndex = val;
				this.GetRoles({enable:this.listParameter.enable})
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			// 启用禁用
			seachTab(type) {
				this.submitParameter.Enable = type;
			},
			preservation(){
				this.updateRole();
				this.dialogVisible = false;
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/style/variables.scss';
	@import "@/assets/style/mixin.scss";
	.dialogScoped .exportTab .sliderScreeningR a {
		@include bg-color(dialogTabsColor);
	}
</style>
